import ENVIRONMENTS from 'constants/enviroments';
import { isTicketSalesTrackedPath } from 'helpers/ticketSalesTracking';

export const RD_STATION_SCRIPT_ID = 'rd-station-loader';

/**
 * URL do loader de monitoramento da RD Station (REACT_APP_RD_STATION_LOADER_URL).
 * Definida apenas nos clientes que usam o serviço (hoje: CatSul). Vazia = desativado.
 */
export const getRdStationLoaderUrl = () =>
  (ENVIRONMENTS.RD_STATION.LOADER_URL || '').trim();

export const isRdStationEnabled = () => Boolean(getRdStationLoaderUrl());

/**
 * O monitoramento cobre apenas o e-commerce (venda de passagens),
 * nunca o back-office (/bdos) ou os demais módulos do mesmo domínio.
 */
export const isRdStationTrackedPath = isTicketSalesTrackedPath;

/**
 * Injeta o script da RD Station no final do <body> uma única vez, como
 * <script type="text/javascript" async src="...">, conforme a instrução da RD.
 * Retorna true quando o script foi (ou já estava) injetado.
 */
export const loadRdStationScript = (): boolean => {
  const loaderUrl = getRdStationLoaderUrl();
  if (!loaderUrl) return false;
  if (document.getElementById(RD_STATION_SCRIPT_ID)) return true;

  const script = document.createElement('script');
  script.id = RD_STATION_SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = loaderUrl;
  document.body.appendChild(script);
  return true;
};
